export const channel = [{
		name: '微信公众号',
		key: 'wechat',
		id:'wechat',
		type:['text','image','video','voice','news','miniprogrampage'],//可发送以及接收类型
	}, {
		name: '网页',
		key: 'web',
		id:'web',
		type:['text','image','video','voice','news','miniprogrampage','file','link'],
	}, {
		name: '微博',
		key: 'weibo',
		id:'weibo',
		type:['text','image'],
	}, {
		name: '微信小程序',
		key: 'miniProgram',
		id:'miniProgram',
		type:['text','image','miniprogrampage','link'],
	}, {
		name: '抖音',
		key: 'tikTok',
		id:'tikTok',
		type:['text','image','video'],
	}, {
		name: '企业微信',
		key: 'qyWechat',
		id:'qyWechat',
		type:['text','image'],
	}, {
		name: '百度小程序',
		key: 'Baiduminiprogram',
		id:'Baiduminiprogram',
		type:['text','image','miniprogrampage'],
	}, {
		name: '京东小程序',
		key: 'JDongminiprogram',
		id:'JDongminiprogram',
		type:['text','image','video','miniprogrampage'],
	}, {
		name: 'App',
		key: 'app',
		id:'app',
		type:['text','image','video','voice','news','miniprogrampage','file','link'],
	}


]
//留言状态 
export const leave_msg_status = [{
	name: '未回复',
	id: '-1',
	color:'#FF504D',
	type:'danger'
}, {
	name: '未回复已过期',
	id: '-2',
	color:'#FF504D',
	type:'warning'
}, 
// {
// 	name: '未回复即将过期',
// 	id: '-3',
// 	color:'#e6a23c'
// }, 
// {
// 	name: '新建',
// 	id: '1',
// 	color:'#838A9D'
// },
{
	name: '已回复',
	id: '2',
	color:'#47B267',
	type:'success'
},{
	name:'已废弃',
	id:'3',
	color:'#C6D1DD',
	type:'info'
}]
